export const routes = (prefix = `pharmacy`) => [
    {
        path: `/${prefix}/discharged-patients`,
        name: `${prefix}.discharged-patients.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.discharged-patients.index`,
                PageDescription: "Pharmacy - Select patient",
            },
        },
    },
];
